/**
 *
 */
import {getCurrentCommunity} from '../config';


/**
 * @typedef {function|undefined} window.gtag
 */


/**
 * add gtag tracking codes to community pages
 */
const setupCommunityTracking = () =>
{
	const currentCommunity = getCurrentCommunity();

	if (currentCommunity && currentCommunity.trackingCodes.googleTagManagerIds && currentCommunity.trackingCodes.googleTagManagerIds.length) {

		if (typeof window.gtag === 'function') {

			currentCommunity.trackingCodes.googleTagManagerIds.forEach( gtagId =>
			{
				window.gtag( 'config', gtagId );
				console.log( 'applying community gtag id ' + gtagId );
			} );
		}
	}
};


/**
 *
 */
export default setupCommunityTracking;